module.exports = __webpack_public_path__ + "static/media/slider5.c323b716.jpg";